import { grayPalette } from '../../../themes/colors';

export const pageLightTheme = {
  backgroundColor: grayPalette[100],
};
